import { ca } from '@cian/analytics';

export function trackHelpClick() {
  ca('eventSite', {
    name: 'oldevent',
    action: 'Click',
    category: 'Map',
    label: 'help',
  });
}
